import seo from '@/assets/data/seo.json';

export default {
  pages: {
    amsterdam: {},
    toronto: {},
    'san-francisco': {},
  },
  speakers: {
    amsterdam: [],
    toronto: [],
    'san-francisco': [],
  },
  workshops: {
    amsterdam: [],
    toronto: [],
    'san-francisco': [],
  },
  sponsor: {
    amsterdam: [],
    toronto: [],
    'san-francisco': [],
  },
  urlButton: {
    amsterdam: 'https://www.universe.com/events/digital-thinkers-conf-amsterdam-by-awwwards-tickets-amsterdam-KW8RNZ',
    toronto: 'https://www.universe.com/events/digital-thinkers-conf-toronto-by-awwwards-tickets-toronto-J4TFPS',
    'san-francisco': '#',
  },
  loadingData: false,
  inTransition: false,
  isMenuOpen: false,
  message: {
    amsterdam: {},
    toronto: {},
    'san-francisco': {},
  },
  seo,
};
